const initAutocompleteAndMap = function () {
  const input = document.getElementById('address');
  if (!input) return;
  
  const latInput = document.getElementById('address-lat');
  const lngInput = document.getElementById('address-lng');
  const mapDiv = document.getElementById('address-map');
  const mapId = 'FML_MAP';
  if (mapDiv) {
    
    var defaultCenter = {lat: 0, lng: 0}; // Centro Milano
    var map = new google.maps.Map(mapDiv, {
      center: defaultCenter,
      zoom: 12,
      mapId: mapId
    });
    var marker = new google.maps.Marker({map: map, visible: false});
  }
  var autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
  
  autocomplete.addListener('place_changed', function () {
    var place = autocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) return;
    
    var lat = place.geometry.location.lat();
    var lng = place.geometry.location.lng();
    if (map) {
      map.setCenter({lat: lat, lng: lng});
      map.setZoom(15);
      marker.setPosition({lat: lat, lng: lng});
      marker.setVisible(true);
    }
    
    if (lngInput && latInput) {
      latInput.value = lat;
      lngInput.value = lng;
    }
  });
}

// Se Google Maps è già caricato e ha già chiamato lo stub nel layout, eseguiamo l'inizializzazione ora
if (window.googleMapsLoaded) {
  console.log("Google Maps already loaded, initializing now.");
  initAutocompleteAndMap();
}

// Esponiamo la funzione reale per la callback di Google Maps (se non è ancora stata chiamata)
window.initAutocompleteAndMap = initAutocompleteAndMap;
